import styled from 'styled-components'

export const Container = styled.div`
  background: ${props => props.bgColor ? props.bgColor : 'orangered'};
  display: flex;
  color: ${props => props.color ? props.color : 'white'};
  font-weight: bold;
  justify-content: center;
  padding: 0.5em;
`